angular.module('app').controller('salesPriorityOneCtrl', ['$scope', '$location', '$window', 'dummyDataService', 'regionStorageFactory', 'TourService', 'slickConfigService', function($scope, $location, $window, dummyDataService, regionStorageFactory, TourService, slickConfigService) {

    $scope.includeDates = [];

    

    

    $scope.modelHomes = [];
    $scope.showcaseHomes = [];

    if (window.tourData) {
        $scope.region = window.tourData.region;
        $scope.modelHomes = window.tourData.modelHomes;
        $scope.modelHomes.forEach(modelHome => {
            if(modelHome.sales_office_hours){
                $scope.showcaseHomes.push(modelHome);
            }
        });
    } else {
        console.error("SP1 Data not found!");
    }

    $scope.regionId = $scope.region && $scope.region.id ? $scope.region.id : '';

    var agentImages = dummyDataService.agentImages();
    $scope.agentImage = agentImages[$scope.regionId] ? agentImages[$scope.regionId] : 'NHA_Alex_DeBorde1.jpg';
    regionStorageFactory.setRegion($scope.region);

    $scope.showcaseSlickSettings = slickConfigService.baseConfig(1);

    // This serves as our general utour URL if no virtual_tour_link is found for the community's model.
    var regionLinks = {
        Louisville: 'https://fischer.utourhomes.com/visitor?division=5dbe216d-7db3-4ed2-b6e5-121c72c5434b&rootUrl=division&lang=en',
        Dayton: 'https://fischer.utourhomes.com/visitor?division=93aeac7b-178b-418d-b674-b3daf4dc638d&rootUrl=division&lang=en'

    };
    var utourGuestUrl = $scope.region && $scope.region.name && regionLinks[$scope.region.name] ? regionLinks[$scope.region.name] : 'https://fischer.utourhomes.com/visitor';

    $scope.utmContent = $location.search().utm_content || '';
    $scope.communityName = $scope.utmContent.replace(/-/g, ' ').toUpperCase();

    // Single fix for Melody Parks since the sign is already printed and we can't easily change the url.
    $scope.communityName = $scope.communityName == 'MELODY PARKS' ? 'ESTATES AT MELODY PARKS' : $scope.communityName; 
    $scope.communityName = $scope.communityName == 'DISCOVER POINT' ? 'DISCOVERY POINT' : $scope.communityName; 
    $scope.communityName = $scope.communityName == 'MALLARD LAKE' ? 'SANCTUARY AT MALLARD LAKE' : $scope.communityName; 
    $scope.communityName = $scope.communityName == 'CHAMPOINS POINT' ? 'THE MAJORS AT CHAMPIONS POINTE' : $scope.communityName;
    $scope.communityName = $scope.communityName == 'MAJORS AT CHAMPOINS POINTE' ? 'THE MAJORS AT CHAMPIONS POINTE' : $scope.communityName;
    $scope.communityName = $scope.communityName == 'MAJORS AT CHAMPIONS POINTE' ? 'THE MAJORS AT CHAMPIONS POINTE' : $scope.communityName; 
    $scope.utourUrl = '';
    $scope.communityName = $scope.communityName == 'MAJORS AT CHAMPOINS POINT' ? 'THE MAJORS AT CHAMPIONS POINTE' : $scope.communityName;
    $scope.communityName = $scope.communityName == 'FLOYDS FORK' ? 'THE ESTATES AND MEADOWS AT FLOYDS FORK' : $scope.communityName;

    $scope.showSpecialistTour = false;

    $scope.modelHomes.forEach(modelHome => {
        modelHome.communityNameLower = modelHome.formattedCommunity.toLowerCase();
        if(modelHome.communityLocatedFormatted.toUpperCase() == $scope.communityName || modelHome.formattedCommunity.toUpperCase() == $scope.communityName){
            $scope.utourUrl = modelHome.utour_url ? modelHome.utour_url : utourGuestUrl;
            if(modelHome.has_detailed_sales_office_hours){
                let availability = modelHome.detailed_sales_office_hours;

                if (typeof availability === 'string') {
                    try {
                        availability = JSON.parse(availability);
                    } catch (e) {
                        availability = {};
                    }
                }

                const allNull = Object.values(availability).every(v => v === null || v === undefined);

                if(!allNull) {
                    $scope.tourAvailability = availability;

                    if(modelHome.sales_office_hours){
                        $scope.tourAvailability.showcase = true;
                        $scope.tourAvailability.showcase_days = dummyDataService.daytonTourTimes().showcase_days ? dummyDataService.daytonTourTimes().showcase_days : [];
                        $scope.tourAvailability.showcase_start = dummyDataService.daytonTourTimes().showcase_start;
                        $scope.tourAvailability.showcase_end = dummyDataService.daytonTourTimes().showcase_end;
                    } else {
                        $scope.tourAvailability.showcase = false;
                    }
                    $scope.allowToday = TourService.availableToday($scope.tourAvailability);
                    $scope.tourTimes = TourService.generateWeeklyTourTimes($scope.tourAvailability);
                    $scope.formattedTourTimes = TourService.formatTourTimes($scope.tourTimes);
                    $scope.showSpecialistTour = true;
                }

                const dates = modelHome.available_tour_dates;
                if (Array.isArray(dates)) {
                    $scope.includeDates = dates;
                } else if (typeof dates === 'string') {
                    try {
                        $scope.includeDates = JSON.parse(dates);
                    } catch (e) {
                        console.warn('Could not parse tour dates');
                    }
                }
                if (
                    window.tourData &&
                    window.tourData.available_tour_dates &&
                    window.tourData.available_tour_dates.length
                ) {
                    self.includeDates = window.tourData.available_tour_dates;
                    self.modelLocation = window.tourData.tourLocation;
                    self.showSpecialistTour = true;
                }
            }
            

            $scope.tourLocation = modelHome.formattedAddress 
             ? {
                address: modelHome.address,
                city: modelHome.city,
                state: modelHome.state,
                zip: modelHome.zip,
             }
             : '';

            $scope.home = modelHome;
        }
    });

    if(!$scope.utourUrl){
        $scope.utourUrl = utourGuestUrl;
    }

    $scope.tourDayOfWeek = '';

}]);